'use strict'

var setupDefaults = {
  cookies: {
    path: '/'
  },
  treeOptions: {
    parentKey: 'parentId',
    key: 'id',
    children: 'children'
  },
  parseDateFormat: 'yyyy-MM-dd HH:mm:ss',
  firstDayOfWeek: 1
}

module.exports = setupDefaults



//////////////////
// WEBPACK FOOTER
// ./node_modules/xe-utils/setupDefaults.js
// module id = 26
// module chunks = 3